import { ChartCard } from '@/components/shared/chart-card';
import { SimpleBarChart } from '@/components/shared/simple-bar-chart';
import { formatNumber } from '@/utils/format';

interface GroupLargestRow {
  key: string;
  label: string;
  value: number;
}

interface GroupLargestChartsProps {
  loading: boolean;
  largestManual: GroupLargestRow[];
  largestAutoFilled: GroupLargestRow[];
  labels: {
    manualTitle: string;
    manualEmpty: string;
    autoFilledTitle: string;
    autoFilledEmpty: string;
  };
}

export const GroupLargestCharts = ({
  loading,
  largestManual,
  largestAutoFilled,
  labels,
}: GroupLargestChartsProps) => {
  return (
    <div className="grid gap-4 sm:grid-cols-2">
      <ChartCard
        title={labels.autoFilledTitle}
        loading={loading}
        hasData={largestAutoFilled.length > 0}
        empty={{ title: labels.autoFilledEmpty }}
        height={160}
      >
        <SimpleBarChart
          orientation="horizontal"
          data={largestAutoFilled.map((row) => ({
            label: row.label,
            value: row.value,
          }))}
          formatValue={(value) => formatNumber(value)}
          height={140}
        />
      </ChartCard>

      <ChartCard
        title={labels.manualTitle}
        loading={loading}
        hasData={largestManual.length > 0}
        empty={{ title: labels.manualEmpty }}
        height={160}
      >
        <SimpleBarChart
          orientation="horizontal"
          data={largestManual.map((row) => ({
            label: row.label,
            value: row.value,
          }))}
          formatValue={(value) => formatNumber(value)}
          height={140}
        />
      </ChartCard>
    </div>
  );
};
